/* KL 14/10/2026 — PostHog (UE) pour Korea Labs. Réglages lus dans window.KL_PH (snippets/kl-posthog.liquid).
   Toutes les visites sont comptées : sans accord aux cookies, sans cookie (empreinte serveur renouvelée chaque jour,
   pas d'identification) ; avec accord, suivi normal et cliente reconnue par son numéro client Shopify. Chargé après
   l'affichage ; enregistrements, questionnaires, cartes de chaleur et clics morts coupés (Clarity les fait).

   19/10/2026 — plan d'événements v1.0 (docs/strategie/2026-10-18-architecture-posthog/PLAN-EVENEMENTS.md) :
   - accord lu en direct : mode « on_reject » de PostHog ; refus ou pas encore de réponse → opt_out (compté sans
     cookie) ; accord, même en cours de page → opt_in (l'arrivée et sa pub sont gardées) ;
   - identify une seule fois (968 mises à jour de profil inutiles relevées le 19/10) ; reset() à la déconnexion et
     quand plus aucune cliente n'est connectée (poste partagé dans un institut) ;
   - compte_cree une seule fois (26 envois pour 19 comptes relevés le 19/10 : rechargements) ;
   - origine de la visite (visite_*), 1re et dernière touche (origine_1_*, origine_n_*, registre kl-origine) sur chaque
     événement, et sur la fiche de la cliente ;
   - visites du thème d'aperçu marquées apercu = true (à exclure des tableaux). */
(function () {
    'use strict';
    var C = window.KL_PH || {};
    var CLE = C.cle;
    var CLIENTE = C.cliente || null;
    var PRO = !!C.pro;
    var PAGE = { gabarit: C.gabarit || '', produit: C.produit || null, exclu_pro: !!C.exclu_pro };
    var ID = CLIENTE ? 'shopify_' + CLIENTE : null;
    if (!CLE) return;
    var demarre = false;
    var ph = null;

    function etatConsentement() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return 'attente';
      try {
        var v = cp.currentVisitorConsent ? cp.currentVisitorConsent() : null;
        if (v && (v.analytics === 'yes' || v.marketing === 'yes')) return 'oui';
        if (v && v.analytics === 'no') return 'non';
        if (cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed()) return 'oui';
        if (cp.shouldShowBanner && !cp.shouldShowBanner()) return 'non';
      } catch (e) {}
      return 'attente';
    }

    function session(cle, valeur) {
      try {
        if (valeur === undefined) return sessionStorage.getItem(cle);
        sessionStorage.setItem(cle, valeur);
      } catch (e) {}
      return null;
    }

    // Origine (registre kl-origine) → propriétés courtes, sans identifiant de clic en clair.
    function proprietes(o, prefixe) {
      var r = {};
      if (!o) return r;
      var O = window.KL_ORIGINE;
      r[prefixe + 'canal'] = O && O.canal ? O.canal(o) : (o.utm_source || o.site || 'autre');
      if (o.utm_source) r[prefixe + 'source'] = o.utm_source;
      if (o.utm_medium) r[prefixe + 'support'] = o.utm_medium;
      if (o.utm_campaign) r[prefixe + 'campagne'] = o.utm_campaign;
      if (o.utm_term) r[prefixe + 'ensemble'] = o.utm_term;
      if (o.utm_content) r[prefixe + 'pub'] = o.utm_content;
      if (o.utm_id) r[prefixe + 'pub_id'] = o.utm_id;
      if (o.site) r[prefixe + 'site'] = o.site;
      if (o.page) r[prefixe + 'page_arrivee'] = o.page;
      if (o.date) r[prefixe + 'vu_le'] = o.date;
      return r;
    }

    function origine(accord) {
      var O = window.KL_ORIGINE;
      if (!O) return {};
      var props = proprietes(O.page, 'visite_');
      if (accord) {
        var k;
        var p1 = proprietes(O.premiere(), 'origine_1_'), pn = proprietes(O.derniere(), 'origine_n_');
        for (k in p1) props[k] = p1[k];
        for (k in pn) props[k] = pn[k];
      }
      return props;
    }

    function reconnaitre() {
      if (!ph || etatConsentement() !== 'oui') return;
      var actuel = ph.get_distinct_id ? ph.get_distinct_id() : '';
      if (!ID) {
        // Plus de cliente connectée sur cet appareil : on ne range plus ses pages sous son nom.
        if (String(actuel).indexOf('shopify_') === 0) ph.reset();
        return;
      }
      if (actuel !== ID) ph.identify(ID, { pro: PRO });
      if (session('kl_ph_fiche') !== ID) {
        var o = origine(true), set = { pro: PRO }, once = {}, k;
        for (k in o) { if (k.indexOf('origine_1_') === 0) once[k] = o[k]; else if (k.indexOf('origine_n_') === 0) set[k] = o[k]; }
        ph.setPersonProperties(set, once);
        session('kl_ph_fiche', ID);
      }
      try { if (window.clarity) window.clarity('set', 'ph_id', ph.get_distinct_id()); } catch (e) {}
    }

    function appliquerAccord() {
      if (!ph) return;
      var e = etatConsentement();
      var statut = ph.get_explicit_consent_status ? ph.get_explicit_consent_status() : 'pending';
      if (e === 'oui') { if (statut !== 'granted') ph.opt_in_capturing(); }
      else if (statut !== 'denied') ph.opt_out_capturing();
      // Après opt_in / opt_out : PostHog change de stockage, les propriétés communes sont reposées à chaque fois.
      var base = {
        boutique: 'korea-labs',
        theme: (window.Shopify && Shopify.theme && Shopify.theme.name) || '',
        plan_evenements: '1.0',
        source_donnee: 'navigateur',
        accord_cookies: e === 'oui' ? 'oui' : 'non'
      };
      var role = (window.Shopify && Shopify.theme && Shopify.theme.role) || '';
      if (role && role !== 'main') base.apercu = true;
      ph.register(base);
      ph.register(origine(e === 'oui'));
      reconnaitre();
    }

    function etapesDeLaPage() {
      if (PAGE.gabarit === 'product') {
        ph.capture('produit_vu', { produit: PAGE.produit, exclu_pro: PAGE.exclu_pro });
        if (PAGE.exclu_pro && !PRO) ph.capture('prix_masque_vu', { produit: PAGE.produit });
      }
      if (/[?&]kl=compte-cree/.test(location.search)) {
        var cle = 'cc_' + (CLIENTE || 'anonyme');
        if (session('kl_ph_cc') !== cle) { ph.capture('compte_cree', { pro: PRO }); session('kl_ph_cc', cle); }
      }
    }

    function ecouter() {
      document.addEventListener('click', function (ev) {
        var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
        if (!a) return;
        var h = a.getAttribute('href') || '';
        if (h.indexOf('/account/logout') > -1) { try { ph.reset(); } catch (e) {} return; }
        if (h.indexOf('/account/register') > -1) ph.capture('clic_creer_compte', { depuis: location.pathname });
        else if (h.indexOf('/account/login') > -1) ph.capture('clic_se_connecter', { depuis: location.pathname });
      }, true);
      var forms = document.querySelectorAll('form');
      for (var i = 0; i < forms.length; i++) {
        (function (f) {
          var ft = f.querySelector('input[name="form_type"]');
          if (!ft || ft.value !== 'create_customer') return;
          var commence = false;
          f.addEventListener('input', function () {
            if (commence) return;
            commence = true;
            ph.capture('inscription_commencee');
          });
          f.addEventListener('submit', function () {
            ph.capture('inscription_envoyee', {}, { transport: 'sendBeacon' });
          });
        })(forms[i]);
      }
      if (window.fetch && !window.__klPhFetch) {
        window.__klPhFetch = true;
        var f0 = window.fetch;
        window.fetch = function (url) {
          var p = f0.apply(this, arguments);
          try {
            var u = typeof url === 'string' ? url : (url && url.url) || '';
            if (u.indexOf('/cart/add') > -1) {
              p.then(function (r) { if (r && r.ok) ph.capture('ajout_panier', { depuis: location.pathname }); }).catch(function () {});
            }
          } catch (e) {}
          return p;
        };
      }
      document.addEventListener('visitorConsentCollected', function () { setTimeout(appliquerAccord, 300); });
    }

    function demarrer() {
      if (demarre) return;
      demarre = true;
      !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status clear_opt_in_out_capturing debug".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
      posthog.init(CLE, {
        api_host: 'https://eu.i.posthog.com',
        ui_host: 'https://eu.posthog.com',
        defaults: '2026-05-30',
        person_profiles: 'identified_only',
        // Rien n'est stocké sans accord ; refus (ou pas encore de réponse, traité comme un refus) = compté sans cookie.
        cookieless_mode: 'on_reject',
        autocapture: { dom_event_allowlist: ['click', 'submit'], element_allowlist: ['a', 'button', 'form'] },
        // Page vue envoyée à la main, APRÈS l'accord et les propriétés (sinon la 1re page arrive sans sa campagne :
        // écart trouvé par la vérification du 19/10).
        capture_pageview: false,
        capture_pageleave: true,
        disable_session_recording: true,
        disable_surveys: true,
        capture_heatmaps: false,
        capture_dead_clicks: false,
        loaded: function (instance) {
          ph = instance;
          appliquerAccord();
          ph.capture('$pageview');
          etapesDeLaPage();
          ecouter();
        }
      });
    }

    function plusTard() {
      if ('requestIdleCallback' in window) { requestIdleCallback(demarrer, { timeout: 2000 }); } else { setTimeout(demarrer, 1); }
    }
    if (document.readyState === 'complete') { plusTard(); } else { window.addEventListener('load', plusTard); }
  })();
